import Axios from "axios";

export default function CounsellingRound(counsellingYear){
    console.log(counsellingYear);
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'counsellingRound',
            counsellingYear,
          
        }
    });
    return response;
}